export const CAN_LOAD = 'can_load';
export const QUEUE = 'queue';
export const LOADING = 'loading';
export const DONE = 'done';